import { render, staticRenderFns } from "./NtrSign.vue?vue&type=template&id=4b00243e&"
import script from "./NtrSign.vue?vue&type=script&lang=js&"
export * from "./NtrSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports